<div class="modal-header">
  <h4 class="col-12 modal-title text-center">Sign In / Sign Up</h4>
  <button type="button" class="close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="modal-body-content">
    <div class="row">
      <div class="col-sm-12">
        <div class="otp-ver">
          <h4 class="otp-text asterisk-if-mandatory" >
            Enter Mobile number
          </h4>
        </div>
        <form class="theme-form" #signInForm="ngForm">
          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group mb-3">
                <span
                  [ngClass]="{
                    'isvalid': !isMobileError && isMobValid,
                    'notvalid': isMobileError && isMobValid
                  }"
                >
                  <input
                    type="text"
                    [ngClass]="{
                      'isvalid': !isMobileError && isMobValid,
                      'notvalid': isMobileError && isMobValid
                    }"
                    class="form-control"
                    [(ngModel)]="user.mobileNumber"
                    id="mobileNumber"
                    name="mobileNumber"
                    #mobileNumber="ngModel"
                    [class.error]="isMobileError"
                    required
                  />
                </span>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isRegistered && submitted">
              <div class="otp-ver">
                <h4 class="otp-text asterisk-if-mandatory">
                  Name
                </h4>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isRegistered && submitted">
              <div class="form-group mb-3">
                <span
                [ngClass]="{
                  'isvalid': !isRegNameValid && isRegisterPressed,
                  'notvalid': isRegNameValid && isRegisterPressed
                }"
              >
                <input
                  type="text"
                  [ngClass]="{
                    'isvalid': !isRegNameValid && isRegisterPressed,
                    'notvalid': isRegNameValid && isRegisterPressed
                  }"
                  class="form-control"
                  [(ngModel)]="user.name"
                  id="name"
                  name="name"
                  #name="ngModel"
                  [class.error]="!name.valid && submitted"
                  required
                />
                </span>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && isRegistered && submitted">
              <div class="otp-ver">
                <h4 class="otp-text asterisk-if-mandatory" required>
                  Enter OTP You Have Received
                </h4>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && isRegistered && submitted">
              <div class="form-group mb-3">
                <ng-otp-input
                #ngOtpInput
                  (onInputChange)="onOtpChange($event)"
                  [config]="{ length: 4 ,
                    allowNumbersOnly: true,
                    inputStyles: {
                    'width': '39px',
                    'height': '39px'
                  }}"
                  name="otp"
                ></ng-otp-input>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser">
              <h4 style="color:red" *ngIf="isRegistered && submitted && !isOtpVerified">
                Invalid OTP
              </h4>
            </div>
            <div class="col-md-12" *ngIf="!isRegistered && submitted">
              <div class="otp-ver">
                <h4 class="otp-text asterisk-if-mandatory" *ngIf="!isMobile">
                  Enter Mobile
                </h4>
                <h4 class="otp-text asterisk-if-mandatory" *ngIf="isMobile">
                  Enter Email
                </h4>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isRegistered && submitted">
              <div class="form-group mb-3">
               <span [ngClass]="{
                'isvalid': !isRegEmailOrMobile && isRegisterPressed && !isRegNameValid,
                'notvalid': isRegEmailOrMobile && isRegisterPressed && !isRegNameValid
              }">
                <input
                  type="text"
                  [ngClass]="{
                    'isvalid': !isRegEmailOrMobile && isRegisterPressed && !isRegNameValid,
                    'notvalid': isRegEmailOrMobile && isRegisterPressed && !isRegNameValid
                  }"
                  class="form-control"
                  [(ngModel)]="user.mobileemail"
                  id="mobileemail"
                  name="mobileemail"
                  #mobileemail="ngModel"
                  [class.error]="!mobileemail.valid && submitted"
                  required
                />
              </span>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && !isRegistered && submitted && otpSent">
              <div class="otp-ver">
                <h4 class="otp-text asterisk-if-mandatory" required>
                  Enter OTP You Have Received
                </h4>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && !isRegistered && submitted && otpSent">
              <div class="form-group mb-3">
                <ng-otp-input
                #ngOtpInput
                  (onInputChange)="onOtpChange($event)"
                  [config]="{ length: 4 ,
                    allowNumbersOnly: true,
                    inputStyles: {
                    'width': '39px',
                    'height': '39px'
                  }}"
                  name="otp"
                ></ng-otp-input>
              </div> 
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && isRegistered && submitted && !(timeLeft == 0)">
              <div class="form-group mb-3">
                <p>{{timeLeft}} Seconds Left....</p>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && !isRegistered && submitted && otpSent && !(timeLeft == 0)">
              <div class="form-group mb-3">
                <p>{{timeLeft}} Seconds Left....</p>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && isRegistered && (timeLeft == 0)">
              <div class="form-group mb-3">
                <a href="#" (click)="resendOTP()">Resend OTP</a>
              </div>
            </div>
            <div class="col-md-12" *ngIf="!isProxyUser && !isRegistered && submitted && otpSent && (timeLeft == 0)">
              <div class="form-group mb-3">
                <a href="#" (click)="resendOTP()">Resend OTP</a>
              </div>
            </div>
            <!--<div *ngIf="showVerifySuccess">
              <div class="form-group mb-3">
                <span style="color: rgb(62, 233, 62)">Verified Success</span>
              </div>
            </div>-->
            <div class="col-md-12"*ngIf="!isProxyUser">
              <h4 style="color:red" *ngIf="!isRegistered && submitted && otpSent  && !isOtpVerified">
                Invalid  OTP
              </h4>
            </div>
            <div class="col-md-12">
              <button
                class="btn btn-solid next-btn"
                (click)="verifyMobileNumber(signInForm)"
                type="submit"
                *ngIf="!submitted"
              >
                Next
              </button>
              <button
                class="btn btn-success next-btn"
                (click)="getOTP()"
                type="submit"
                *ngIf="!isProxyUser && !isRegistered && submitted && !otpSent"
              [disabled]="!user.mobileemail && !user.name"
              >
                Get OTP
              </button>
              
              <div *ngIf="!isProxyUser && !isRegistered && submitted && otpSent">
                <input type="checkbox" name="agreeTC" value="check" id="agree"  [(ngModel)]="checked" [required] /> I have read and agree to the 
                <a [routerLink]="['pages/termsAndConditions']" target="_blank"
                >Terms & Conditions </a> and  <a [routerLink]="['pages/privacypolicy']" target="_blank"> Privacy Policy </a> 
                   </div>
				   
				<button
                class="btn btn-success next-btn"
                (click)="verifyOTPandRegister()"
                type="submit"
                [disabled]="!checked"
                *ngIf="!isRegistered && submitted && otpSent">
                Register
              </button>

              <!--<button
                class="btn btn-solid next-btn"
                (click)="registerUser()"
                type="submit"
                *ngIf="!isRegistered && submitted && showRegisterBtn"
              >
                Register
              </button> -->
              <button
                class="btn btn-solid next-btn"
                (click)="verifyOTP()"
                type="submit"
                *ngIf="isRegistered && submitted"
              >
                Sign In
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
